import { name } from './name';
import { created } from './created';

export const columns = [name, created];
